import React, { FormEvent, useContext, useEffect, useState } from 'react'
import { Alert, Button, DatePicker, Form, Input, Layout, Menu, message, Tabs, TabsProps } from 'antd'
import { getRequestAuth, postRequestAuth, putRequestAuth } from '../../../request/request';
import moment from 'moment';
import { AppContext } from '../../../App';
import { ContextType } from '../../../type/type';
import { useTranslation } from 'react-i18next';
import validatorServerErrors from '../../../modules/ValidatorServerErrors/ValidatorServerErrors';
import { JWT, ME } from '../../../reduser/Reduser';
import { useLocation, useNavigate } from 'react-router-dom'
import { validateAge } from '../../../function/validateAge';
import InputMask from 'react-input-mask'
import '../style/styleProfile.scss'
import BottomMenuInfo from '../../../modules/BottomMenuInfo/BottomMenuInfo';

type FieldType = {
  username?: string
  password?: string
  remember?: string
}

const Phone = () => {
  const { state, dispatch, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [about_me] = Form.useForm();
  const [form_phone] = Form.useForm()
  const [form_email] = Form.useForm()
  const [form_password] = Form.useForm()
  const [form_change_phone] = Form.useForm()
  const [userId, setUserId] = useState(null)
  const [dateBirthday, setDateBirthday] = useState(null)
  const [userPhone, setUserPhone] = useState(null)
  const [reload, setReload] = useState(false)
  const [validateErrors, setValidateErrors]: any = useState({})
  const [isLoading, setLoading] = useState(false)
  const [step, setStep] = useState(1)
  const [changePhone, setChangePhone] = useState(true)
  const dateFormat = 'YYYY-MM-DD'
  const dateFormatCalendar = ['YYYY-MM-DD', 'DD.MM.YYYY']
  const [code, setCode] = useState('')
  const [phone, setPhone] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    getRequestAuth('/profile/about_me/')
      .then((res: any) => {
        const {
          first_name,
          last_name,
          middle_name,
          date_birthday,
          user: { id, phone, email },
        } = res?.data || {}

      const newDate: any = moment(date_birthday, dateFormat)

      setUserId(id)
      setDateBirthday(date_birthday)

      about_me.setFieldsValue({
        first_name,
        last_name,
        middle_name,
        date_birthday: date_birthday ? newDate : '',
      })

      form_email.setFieldsValue({
        email,
      })

      setUserPhone(phone)
      form_phone.setFieldsValue({
        phone,
      })
    })
    .catch((err) => {
      validatorServerErrors(err.data)
      dispatch({
        type: JWT,
        payload: null,
      })
      navigate('/cabinet')
    })
  }, [reload, state.lang])

  const onFinishFailed = (errorInfo: any) => {
    console.log('errorInfo', errorInfo)
  }

  const disabledDate = (current: any) => {
    const minDate = new Date(1900, 0, 1)
    const maxDate = moment()
    return current && (current < minDate || current > maxDate)
  }

  const convertDate = (value: any) => {
    return moment(value).format(dateFormat)
  }
    
  const onFinish = (values: any, type: string) => {
    console.log(type)
    setLoading(true)
  
    if (type === 'form_phone') {
      delete values.phone
      const new_phone = values?.new_phone?.replace(/[^\d+]/g, '')
      postRequestAuth('/profile/change_phone/', { ...values, new_phone })
        .then((res) => {
          setPhone(new_phone)
          message.success(res?.data?.status)
          setLoading(false)
          setChangePhone(false)
          // postRequestAuthNew('/auth/get_code_from_redis/', { phone: new_phone })
          //   .then((res) => {
          //     setCode(res?.data?.code)
          //     setChangePhone(false)
          //   })
          //   .catch((err) => {
          //     console.log('err', err)
          //   })
        })
        .catch((err) => {
          validatorServerErrors(err.data, setValidateErrors)
          setLoading(false)
        })
    }
    if (type === 'form_change_phone') {
      const phone = values?.new_phone?.replace(/[^\d+]/g, '')

      postRequestAuth('/profile/confirm_new_phone/', { ...values, phone })
        .then((res) => {
          message.success(res?.data?.status)
          setLoading(false)
          setChangePhone(false)
          // removeCookiesWithRetries({
          //   cookieNames: ['jwt', 'refresh'],
          //   maxRetries: 10,
          //   delay: 100,
          //   cookies,
          //   removeCookie,
          //   navigate,
          //   dispatch,
          // })

          localStorage.removeItem('jwt')
          localStorage.removeItem('refresh')
          dispatch({
            type: JWT,
            payload: null,
          })
          navigate('/')
        })
        .catch((err) => {
          validatorServerErrors(err.data, setValidateErrors)
          setLoading(false)
        })
    }
    
  }

    const handleNewCode = () => {
      if (!userPhone) {
        message.error(`${t('h92')} - ${t('h56')}`)
        return false
      }
  
      postRequestAuth('/auth/send_sms_code/', { phone: userPhone })
        .then((res) => {
          message.success(res?.data?.status)
        })
        .catch((err) => {
          validatorServerErrors(err.data, setValidateErrors)
        })
    }
  

  return (
    <>
    { isMobileWidth && <h3 className='profile-title'>{t('h77')}</h3> }
    { changePhone ? (
      <Form
        form={form_phone}
        name="basic"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={(e) => onFinish(e, 'form_phone')}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item<FieldType>
          label={t('h64')}
          name="phone"
          rules={[{ required: true, message: `${t('h48')} ${t('h64')}` }]}
          validateStatus={validateErrors?.phone ? 'error' : ''}
          help={validateErrors?.phone}
        >
          <InputMask mask="+375(99)999-99-99" disabled>
            <Input />
          </InputMask>
        </Form.Item>
     
          {step === 2 && (
            <>
              <Form.Item<FieldType>
                label={t('h83')}
                name="new_phone"
                rules={[{ required: true, message: `${t('h48')} ${t('h64')}` }]}
                validateStatus={validateErrors?.new_phone ? 'error' : ''}
                help={validateErrors?.new_phone}
              >
                <InputMask mask="+375(99)999-99-99">
                  <Input />
                </InputMask>
              </Form.Item>
              <Form.Item<FieldType>
                label={t('h54')}
                name="password"
                rules={[{ required: true, message: `${t('h48')} ${t('h54')}` }]}
                validateStatus={validateErrors?.password ? 'error' : ''}
                help={validateErrors?.password}
              >
                <Input.Password />
              </Form.Item>
     
              <div className="text-center">
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  {t('h81')}
                </Button>
              </div>
            </>
          )}
     
          {step === 1 && (
            <div className="text-center">
              <Button type="primary" onClick={() => setStep(2)} className={ isMobileWidth ? 'mobile-button-submit' : 'color_btn'}>
                {t('h82')}
              </Button>
            </div>
          )}
        </Form>
      ) : (
        <Form
          form={form_change_phone}
          name="basic"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={(e) => onFinish(e, 'form_change_phone')}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item<FieldType>
            label={t('h64')}
            name="phone"
            rules={[{ required: true, message: `${t('h48')} ${t('h64')}` }]}
            validateStatus={validateErrors?.phone ? 'error' : ''}
            help={validateErrors?.phone}
          >
            <InputMask mask="+375(99)999-99-99" disabled>
              <Input />
            </InputMask>
            </Form.Item>
     
            <Form.Item<FieldType>
              label={t('h83')}
              name="new_phone"
              initialValue={phone}
              rules={[{ required: true, message: `${t('h48')} ${t('h64')}` }]}
              validateStatus={validateErrors?.phone ? 'error' : ''}
              help={validateErrors?.phone}
            >
              <InputMask mask="+375(99)999-99-99">
                <Input />
              </InputMask>
              </Form.Item>
              <Form.Item<FieldType>
                label={t('h57')}
                name="code"
                initialValue={code}
                rules={[{ required: true, message: `${t('h48')} ${t('h57')}` }]}
                validateStatus={validateErrors?.code ? 'error' : ''}
                help={validateErrors?.code}
              >
                <Input />
              </Form.Item>
              <p>
                <span className="cursor-pointer" onClick={handleNewCode} style={{ color: '#4f682a' }}>
                  {t('h72')}
                </span>
              </p>
              <div className="text-center">
                <Button 
                  type="primary"
                  htmlType="submit" 
                  loading={isLoading}
                  className={ isMobileWidth ? 'mobile-button-submit' : 'color_btn'}>
                    {t('h81')}
                </Button>
              </div>
            </Form>
          )
        }
        { isMobileWidth && <BottomMenuInfo type="man" /> }
      </>
    )
}

export default Phone
